import { render, staticRenderFns } from "./LimitsAmount.vue?vue&type=template&id=42d99578&scoped=true"
import script from "./LimitsAmount.vue?vue&type=script&lang=js"
export * from "./LimitsAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d99578",
  null
  
)

export default component.exports